module.exports = __webpack_public_path__ + "static/media/shieldIcon.28c6cdd7.svg";